import { gql } from '@apollo/client';

export const getEvent = gql`
  query getEvent($id: String!) {
    node(id: $id) {
      ... on EventRegistration {
        id
        name
        maxNumberOfRegistrations
        numberRegistered
        registrationOpens
        registrationCloses
        status
        waitlistAvailable
      }
    }
  }
`;
